import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * TestModeBanner - Shows a warning banner when running in development/preview environments
 * Helps distinguish between test and production modes
 */
export default function TestModeBanner() {
  const [dismissed, setDismissed] = useState(false);
  
  // Determine if we're in a test/dev environment
  const isProduction = window.location.hostname === 'monkmode.fit';
  const isPreview = window.location.hostname.includes('preview.emergentagent.com');
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  // Only show banner in non-production environments
  const showBanner = !isProduction && (isPreview || isLocalhost);
  
  if (!showBanner || dismissed) {
    return null;
  }
  
  const environmentLabel = isLocalhost ? 'LOCAL DEV' : 'PREVIEW';
  
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-[#FDF0EC]0 text-black px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertTriangle className="w-4 h-4" />
          <span className="font-bold text-sm">
            {environmentLabel} MODE
          </span>
          <span className="text-sm opacity-80">
            — This is a test environment. Stripe payments are using LIVE keys but this is not production.
          </span>
        </div>
        <button 
          onClick={() => setDismissed(true)}
          className="p-1 hover:bg-amber-600 rounded transition-colors"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
